export const LOGOUT_MESSAGE_TIME = 2000;
